import type { QuickSearchHierarchyResult } from '@/types/searchTypes'
import type { Family } from '@/types/treeViewTypes'

function extractFamilyId(result: QuickSearchHierarchyResult) {
  if (typeof result.code === 'number' && Number.isFinite(result.code)) {
    return result.code
  }

  const suffix = Number(result.id.split('-').at(-1))
  return Number.isFinite(suffix) ? suffix : 0
}

export function mapQuickSearchFamily(result: QuickSearchHierarchyResult): Family {
  return {
    id: extractFamilyId(result),
    labels: result.labels,
  }
}
